import React, { useEffect, useState } from "react";
import Aside from "./Aside/Aside";
import Friends from "./Friends/Friends";
import Map from "./Map/Map";
import "../../assets/styles/Profile/Profile.css";
import { Server2 } from "../../redux/actions/auth/auth.actions";
import { MdApartment, MdLocalPhone, MdOutlineLanguage } from "react-icons/md";
import axios from 'axios'
import GalleryProfile from "../../components/GalleryProfile";
import ModalImage from "react-modal-image";
import { useTranslation } from "react-i18next";
import { parsePhoneNumberFromString } from "libphonenumber-js";
const ShareProfile = ({ userData }) => {

  const { t } = useTranslation();
  const urls = userData?.business_info?.address?.split(/[\s,]+/).filter(Boolean);

  if (userData.type === true) {
    var str = userData?.business_info?.address;
    if (str.length > 10) {
      // var address = str.substring(0, 25);
    }
  }
  const [GallaryImg, setGallaryImg] = useState([]);
  const [NewData, setNewData] = useState();
  useEffect(() => {
    let data = {
      user: userData._id,
    };
    var config = {
      method: "post",
      url: Server2 + "/users/get-gallery-images",
      headers: { "Content-Type": "application/json" },
      data: data,
    };
    axios(config)
      .then((response) => {
        setGallaryImg(response.data);
      })
      .catch((err) => {
        console.log(err, "error");
      });
    getOpeningHours()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const getOpeningHours = () => {
    fetch(
      Server2 + `/users/userprofile?id=${userData._id}&user=${userData._id}`,
      {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      }
    ).then(async (response) => {
      const data = await response.json();
      setNewData(data.user)
    });
  }

  const to12Hour = (time24) => {
    const [h, m] = time24.split(":");
    let hour = parseInt(h);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12;
    return `${hour}:${m} ${ampm}`;
  };

  const formatPhoneNumber = (countryCode, phone) => {
    if (!countryCode || !phone) return '';

    const parsed = parsePhoneNumberFromString(phone, countryCode);

    if (!parsed) return `${phone}`;

    const formatted = parsed.formatInternational();

    const result = formatted.replace(/^(\+\d+\s)(.*)$/, (_, prefix, rest) => {
      return prefix + rest.replace(/\s+/g, '-');
    });

    return result;
  };


  return (
    <div className="bg-white">
      <div className="px-3 py-2">
        <div>
          <div className="img-cover rounded-3 ">
            <ModalImage
              hideDownload
              className="cover "
              small={
                userData?.cover_pic
                  ? userData?.cover_pic
                  : "/Images/dummy2.png"
              }
              large={
                userData?.cover_pic
                  ? userData?.cover_pic
                  : "/Images/dummy2.png"
              }
              alt={`${userData.fname} ${userData.lname}`}
            />
          </div>
          <div className="profile row d-flex px-0 justify-content-center align-items-center">
            <div className="col-lg-2 col-md-3 col-sm-12 order-lg-1 order-md-1 order-2 text-center text-md-end">
              <ModalImage
                hideDownload
                className="img-admin img-fluid shadow"
                small={
                  userData.profile_pic
                    ? userData.profile_pic
                    : "/img/upload-photo.png"
                }
                large={
                  userData.profile_pic
                    ? userData.profile_pic
                    : "/img/upload-photo.png"
                }
                alt={`${userData.fname} ${userData.lname}`}
              />
            </div>
            <div className="col-lg-5 col-md-3 col-sm-12 order-lg-2 order-md-2 order-1 pt-3 ">
              <p
                className="fw-bold fs-3 text-lg-start text-md-start text-center text-white"
                style={{ textShadow: "1px 1px #000000" }}
              >
                {userData.fname} {userData.lname}
              </p>
            </div>
            <div className="col-lg-5 col-md-6 order-lg-2 order-md-2 "></div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-8 col-md-12 col-sm-12 mt-5 ">
            <div
              style={{
                // height: "87px",
                // overflow: "auto",
                marginBottom: "15px",
              }}
            >
              <p
                className="fw-bold text-dark ps-2"
                style={{ fontSize: "16px" }}
              >
                {t('businessSummary')}
              </p>
              <p
                className="text-dark ps-2 mt-1"
                style={{ fontSize: "12px", lineHeight: "18px" }}
              >
                {userData.business_info.business_summary === null
                  ? " "
                  : userData.business_info.business_summary}
              </p>
            </div>
            {/* Business Offers */}
            <div className="border1"></div>
            <div className="rounded-3 shadow  px-3 py-3 mb-3">
              {/* Contacts */}
              <div className="row text-dark">
                <div className="pt-2 pe-xxl-4 pe-xl-3 pe-lg-2">
                  <span className="fw-bold fs-6">{t('businessOffer')}</span>
                  <p className="" style={{
                    minHeight: "40px",
                    maxHeight: "fit-content",
                    // overflow: "auto",
                    marginBottom: "5px",
                  }}>
                    {userData?.business_info?.about_company.map((about, Index) => {
                      const last = userData?.business_info?.about_company.slice(-1)[0]
                      return (
                        <span
                          key={Index}
                          className=""
                          style={{
                            fontSize: "12px",
                            font: "Roboto",
                            fontWeight: "300",
                          }}
                        >
                          {about}{about === last ? null : ","} &nbsp;
                        </span>
                      )
                    })}
                  </p>
                </div>
              </div>
            </div>
            <div className="border1"></div>
            <div className="rounded-3 shadow p-4">
              {/* Contacts */}
              <div className="row text-dark mb-2 text-size w-100">
                <div className="pe-xxl-4 pe-xl-3 pe-lg-2 col-6">
                  <span className="fw-bold text-heading-size">{t('openingHours')}</span>
                  <table>
                    <tbody>
                      {NewData?.business_info?.timeZone ?
                        <tr>
                          <td>{t('timeZone')}</td>
                          <td>:&nbsp;</td>
                          <td>{NewData?.business_info?.timeZone ? NewData?.business_info?.timeZone : 'Not Set' }</td>
                        </tr> : ''
                      }
                      {NewData?.business_info?.business_hours?.map((dayInfo, index) => {
                        return (
                          <tr key={index}>
                            <td style={{ verticalAlign: 'top' }}>{dayInfo.day}</td>
                            <td style={{ verticalAlign: 'top' }}>:&nbsp;</td>
                            <td>
                              {dayInfo.isOff ? (
                                "Closed"
                              ) : (
                                dayInfo.timeSlots.map((slot, idx) => (
                                  <div key={idx}>
                                    {to12Hour(slot.opening)} - {to12Hour(slot.closing)}
                                    {idx !== dayInfo.timeSlots.length - 1 && <br />}
                                  </div>
                                ))
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>

                <div className="ps-xxl-5 ps-xl-4 ps-lg-3 col-6">
                  <span className="fw-bold text-heading-size pb-2">
                    {t('aboutBusiness')}
                  </span>
                  <div className="d-flex align-items-center about-b-divs pb-1 text-nowrap">
                    <MdLocalPhone
                      className="icon-size me-2"
                      style={{ minWidth: "20px" }}
                      color="#6599AF"
                    />
                    <span className="fw-bold text-size">
                      {t('businessContact')}:
                    </span>
                    <span className="p-text-size">
                      &nbsp;{formatPhoneNumber(userData.business_info.country_code, userData.business_info.phone_number)}
                    </span>
                  </div>
                  <div className="d-flex align-items-center about-b-divs pb-1 text-nowrap">
                    <MdApartment
                      className="icon-size me-2"
                      style={{ minWidth: "20px" }}
                      color="#6599AF"
                    />
                    <span className="fw-bold text-size">
                      {t('businessCategory')}:
                    </span>
                    <span className="F-text-size">&nbsp;{userData.business_category}</span>
                  </div>
                  <div className="d-flex align-items-start about-b-divs pb-1">
                    <MdOutlineLanguage
                      className="me-2 icon-size"
                      style={{minWidth:"20px"}}
                      color="#6599AF"
                    />
                    <div className="d-flex flex-column mt-n1">
                    {urls?.length > 0 ? urls?.map((url, index) => {
                      const href = url.startsWith("http") ? url : `https://${url}`;
                      return (
                        <div className="d-flex">
                        <span className="fw-bold text-size text-nowrap">
                          {t('websiteUrl')}:
                        </span>
                        <div className="d-flex flex-column about-b-url ms-1">
                          <a
                            key={index}
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-decoration-none adress-size"
                            title={url}
                            style={{ color: "#6148a1" }}
                          >
                            {url}
                          </a>
                        </div>
                        </div>
                      );
                    }): 
                    <span className="fw-bold text-size text-nowrap">
                      {t('websiteUrl')}:
                    </span>
                    }
                    </div>
                  </div>
                </div>
              </div>
              {/* ^ Gallary */}
              <GalleryProfile GallaryImg={GallaryImg} id={userData?._id} />
            </div>

            {/* Map Start */}
            <div style={{ marginTop: "15px" }}>
              <Map userData={userData} />
            </div>
            {/* Friends */}
            <Friends userData={userData} />
            {/* ^ Map End */}
          </div>
          <div className="col-lg-4 col-md-12 col-sm-12">
            <Aside userData={userData} />
            {/* ^ New Post Div */}
          </div>
          {/* ^ Col-4 */}
        </div>
      </div>
    </div>
  );
};

export default ShareProfile;